import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { EntityApiKeysRepository } from "@entity-api-keys/data/repositories/entity-api-keys.repository";
import { inject, injectable } from "inversify";

@injectable()
export class ExportPublicApiUsageStatsXlsxUseCase {
    constructor(
        @inject(EntityApiKeysRepository)
        private readonly repository: EntityApiKeysRepository,
    ) {}

    async execute(period: string): Promise<Blob> {
        const result = await this.repository.exportUsageStatsXlsx(period);

        if (result.isLeft()) {
            ToastManagerStore.error(result.getLeftOrThrow().message);
        }

        return result.getOrThrow();
    }
}
